/**
 * Returns the user-facing display name for a flavor.
 * Burstable types B12 and B50 (e.g. in OCI 'VM.E3.Flex-B12.M2.VCPU2') are
 * shown as AA and BB in place; the rest of the name is unchanged. Internal
 * state and API keep B12/B50.
 */
export function getFlavorDisplayName(
  flavor: string | undefined | null
): string {
  if (flavor == null || flavor === '') {
    return '';
  }
  return flavor.replace(/B50/g, 'BB').replace(/B12/g, 'AA');
}
